import { render, staticRenderFns } from "./transDetail.vue?vue&type=template&id=39acc0c6&scoped=true"
import script from "./transDetail.vue?vue&type=script&lang=js"
export * from "./transDetail.vue?vue&type=script&lang=js"
import style0 from "./transDetail.vue?vue&type=style&index=0&id=39acc0c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39acc0c6",
  null
  
)

export default component.exports